import { useLang } from "@/i18n/LangContext";

export const STATUS_LABEL_KEYS = {
  programado: "status.programado",
  en_curso: "status.en_curso",
  pausado: "status.pausado",
  finalizado: "status.finalizado",
  retraso: "status.retraso",
};

// Mantener compat con consumidores externos (no usado actualmente fuera).
export const STATUS_LABELS = {
  programado: "Programado",
  en_curso: "En curso",
  pausado: "Pausado",
  finalizado: "Completado",
  retraso: "Con retraso",
};

export const StatusPill = ({ status }) => {
  const { t } = useLang();
  const label = t(STATUS_LABEL_KEYS[status] || status, STATUS_LABELS[status] || status);
  return (
    <span className={`sns-pill st-${status}`} data-testid={`status-${status}`}>
      {(label || status).toUpperCase()}
    </span>
  );
};

export const EmptyState = ({ title, subtitle, children }) => (
  <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
    <div className="w-20 h-20 rounded-2xl bg-[var(--sky)] flex items-center justify-center mb-4">
      <span className="text-3xl">🫧</span>
    </div>
    <h3 className="sns-title text-xl mb-1">{title}</h3>
    {subtitle && <p className="text-slate-500 text-sm max-w-xs mb-4">{subtitle}</p>}
    {children}
  </div>
);

export const Spinner = ({ label }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-12" role="status" data-testid="loading-spinner">
    <div className="w-10 h-10 border-[3px] border-[var(--sky)] border-t-[var(--coral)] rounded-full animate-spin" />
    {label && <span className="text-sm font-semibold text-[var(--sky-text)]">{label}</span>}
  </div>
);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  const months = ["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"];
  return { day: d, month: months[parseInt(m, 10) - 1], year: y };
};
export const fmtDateLong = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};
